import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: "Inter", sans-serif;
  }

  html, body, #root {
    height: 100%;
  }

  #root {
    margin: 0 auto;
    max-width: ${(props) => props.theme.maxContentWidth};
    position: relative;
    display: flex;
    flex-direction: column;
  }

  :where(.ant-typography),
  :where(.ant-typography) * {
    color: inherit;
  }

  .ant-collapse-header {
    background-color: ${(props) =>
        props.theme.collapseHeaderBackground} !important;
    border-radius: 0 !important;
  }

  .update-notification {
    position: absolute;
    height: 100vh;
    width: 100%;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(128, 128, 128, 0.5);
  }

  .ant-select-dropdown {
    .ant-select-item-option-selected {
      background-color: ${(props) =>
          props.theme.secondaryBorderColor} !important;
    }

    .ant-select-item {
      display: flex;
      align-items: center;
      min-height: 38px;
      padding: 8px 12px;
      height: auto;
    }

    .ant-select-item-option-content {
        font-size: 14px;
    }
  }

  .ant-select-selection-item {
    font-size: 14px;
  }

  .ant-select-selection-placeholder {
    font-size: 14px; 
  }

  .ant-dropdown-menu {
    .ant-dropdown-menu-item-disabled {
      .ant-dropdown-menu-title-content {
        span, article {
          color: ${(props) => props.theme.disabledTypographyColor} !important;
        }
      }
    }  
  }

  .ant-picker-panels > *:first-child button.ant-picker-header-next-btn {
        visibility: visible !important;
      }

      .ant-picker-panels > *:first-child button.ant-picker-header-super-next-btn {
        visibility: visible !important;
      }

      .ant-picker-panels > *:last-child {
        display: none !important;
      }

      .ant-picker-panel-container, .ant-picker-footer {
        width: 290px !important;
      }

      .ant-picker-range-arrow {
        display: none !important;
      }

      .ant-picker-panel-container {
        margin-left: auto !important;
      }

      .ant-picker-cell-in-range::before, .ant-picker-cell-range-start::before, .ant-picker-cell-range-end::before {
        background:${(props) =>
            props.theme.selectedCalendarDaysColor} !important;
      }

      .ant-picker-dropdown {
          display: flex !important;
          justify-content: center !important;
        }

      .ant-picker-dropdown.ant-picker-dropdown-hidden {
        display: none !important;
      }

      .week-calendar {
        
        .ant-picker-cell {
          padding: 0 !important;
        }

      }

  .ant-popover-content {
    .ant-btn {
      width: 75px;
      height: 32px;
    }
  }

  .ant-typography p {
    margin: 0
  }

  input,
  textarea,
  select {
    font-size: 16px !important;
    line-height: 1.2 !important;
  }
`;
